import { Thumbnail, ThumbnailProps } from "@shopify/polaris";
import React, { useEffect } from "react";
//@ts-ignore
import { pdfjs } from "react-pdf/dist/esm/entry.webpack";
import { Document, Page } from "react-pdf";

export function Image(props: ThumbnailProps) {
  const extension = String(props.source).split(".")[String(props.source).split(".").length - 1];
  const protocol = String(props.source).split("//")[0];

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  if (extension === "pdf") {
    const option = {
      uri: !protocol ? (window.location.protocol ?? "http:") + props.source : props.source,
      method: "GET",
      headers: { "Cache-Control": "no-cache", "Access-Control-Allow-Origin": "*" },
      body: "",
    };

    return (
      <div style={{ width: 58, height: 58, position: "relative", overflow: "hidden", padding: "0.00625rem" }}>
        <a href={option.uri + ""} target="_blank" rel="noopener noreferrer">
          <Document
            file={option.uri + ""}
            renderMode="svg"
            error={
              <small>
                Preview <br /> PDF
              </small>
            }
            options={{
              httpHeaders: {
                AllowOrigin: "*",
              },
            }}
          >
            <Page pageNumber={1} width={58} height={58} />
          </Document>
        </a>
      </div>
    );
  }

  return (
    <a href={props.source + ""} target="_blank" rel="noopener noreferrer">
      <Thumbnail {...props} />
    </a>
  );
}
